import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axiosInstance from '../axiosInstance';

const SiteConfigContext = createContext({});

export const SiteConfigProvider = ({ children }) => {
  const [siteConfig, setSiteConfig] = useState({
    site_name: 'LemonSocial',
    login_enabled: true,
    registration_enabled: true,
    social_links: {},
    feature_toggles: null,
    modules: {},
  });
  const [loaded, setLoaded] = useState(false);

  const fetchConfig = useCallback(async () => {
    try {
      const res = await axiosInstance.get('/site-config');
      if (res.data?.success) {
        setSiteConfig(res.data.data);
      }
    } catch (e) {
      // Silently fail — defaults are safe
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const isFeatureEnabled = useCallback((featureId) => {
    if (!siteConfig.feature_toggles) return true; // null = all enabled
    const ft = siteConfig.feature_toggles[featureId];
    if (!ft) return true; // unknown feature = enabled
    return ft.enabled !== false;
  }, [siteConfig.feature_toggles]);

  const getFeatureLabel = useCallback((featureId, defaultLabel) => {
    if (!siteConfig.feature_toggles) return defaultLabel;
    const ft = siteConfig.feature_toggles[featureId];
    if (!ft || !ft.label) return defaultLabel;
    return ft.label;
  }, [siteConfig.feature_toggles]);

  const isModuleEnabled = useCallback((key) => {
    return Boolean(siteConfig.modules?.[key]);
  }, [siteConfig.modules]);

  return (
    <SiteConfigContext.Provider value={{ siteConfig, loaded, isFeatureEnabled, getFeatureLabel, isModuleEnabled, refetchConfig: fetchConfig }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
export const useModule = (key) => {
  const { isModuleEnabled } = useContext(SiteConfigContext);
  return isModuleEnabled ? isModuleEnabled(key) : false;
};

export default SiteConfigContext;
